import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { ReportsPage } from "@/components/site/ReportsPage";
import { pageSchemas, reportListSchemas } from "@/lib/seo/page-schema";
import { REPORTS } from "@/content/reports";
const DESC =
  "Безплатни доклади от Perceptica с медийно разузнаване, пазарно проучване, анализ на репутацията, кризисен анализ и конкурентно разузнаване в ЮИЕ.";

export const Route = createFileRoute("/bg/reports/")({
  validateSearch: (raw: Record<string, unknown>) => {
    const year = typeof raw.year === "string" && raw.year ? raw.year : undefined;
    const topic = typeof raw.topic === "string" && raw.topic ? raw.topic : undefined;
    const role = typeof raw.role === "string" && raw.role ? raw.role.slice(0, 20) : undefined;
    return { year, topic, role };
  },
  head: () => ({
    meta: [
      { title: "Доклади - медийно разузнаване и пазарно проучване | Perceptica" },
      { name: "description", content: DESC },
      { property: "og:title", content: "Доклади - медийно разузнаване и пазарно проучване | Perceptica" },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Доклади - медийно разузнаване и пазарно проучване | Perceptica" },
      { name: "twitter:description", content: DESC },
      { property: "og:url", content: "https://perceptica.com/bg/reports" },
      ...ogImageMeta("bg", "/reports"),
    ],
  
    scripts: [
      ...pageSchemas({
      locale: "bg",
      path: "/reports/index",
      service: {
        name: "Персонализирани медийни проучвания и секторни доклади",
        description:
          "Perceptica изготвя персонализирани медийни проучвания и секторни доклади за комуникационни, маркетинг и стратегически екипи в Югоизточна Европа.",
        serviceType: "Custom Media Research & Sector Reporting",
        category: "Медиен анализ",
      },
      collection: { name: "Perceptica reports", description: "Original research from Perceptica" },
      }),
      ...reportListSchemas({
        locale: "bg",
        reports: REPORTS.map((r) => ({ title: r.titleBg ?? r.title, slug: r.slug, year: r.year })),
      }),
    ],
  }),
  component: ReportsPage,
});
